import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Description } from '@mui/icons-material';
import { Paper, Stack, Typography } from '@mui/material';
import React from 'react';
import { RichTextbox } from '../richtext/index.js';
export function BiographySection(props) {
    const { character, canEdit = false } = props;
    const handleBioChange = React.useCallback((value) => {
        character.bio = value || undefined;
    }, [character]);
    return (_jsxs(Paper, { component: "section", variant: "outlined", sx: { p: 3 }, children: [_jsxs(Stack, { direction: "row", spacing: 1, alignItems: "center", sx: { mb: 2 }, children: [_jsx(Description, { color: "primary" }), _jsx(Typography, { variant: "h6", component: "h2", children: "Biography" })] }), _jsx(RichTextbox, { contentId: `${character.id}-bio`, content: character.bio ?? '', onChange: handleBioChange, canEdit: canEdit, placeholder: "No biography available." })] }));
}
//# sourceMappingURL=BiographySection.js.map